// @flow
import ConfigItemContainer from './containers/ConfigItemContainer';

export default ConfigItemContainer;